import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../../src/constants/premissions'
import { priceReportParamsSchema, priceReportSearchSchema } from '../../../src/schemas/routeSchemas'
import { requirePermission } from '../../../src/utils/routePermissions'

export const Route = createFileRoute('/valuation-report/$mmsi')({
  validateSearch: (search) => priceReportSearchSchema.parse(search),
  params: {
    parse: (params) => priceReportParamsSchema.parse(params),
  },
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  staticData: {
    englishAllowed: true,
    permissionRequired: PERMISSION_ROLES.VALUATION_REPORT,
  },
})
